<template>
  <main class="email-verify-page">
    <section class="email-card" aria-labelledby="email-verify-title">
      <div class="mail-visual" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M4.8 6.5h14.4a1.4 1.4 0 0 1 1.4 1.4v9.2a1.4 1.4 0 0 1-1.4 1.4H4.8a1.4 1.4 0 0 1-1.4-1.4V7.9a1.4 1.4 0 0 1 1.4-1.4Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" />
          <path d="m5 8 7 5 7-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          <path d="m17 15 3.4 3.4 5.6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <h1 id="email-verify-title" class="title">Verify Your Email</h1>
      <p class="description">
        Click the button below to confirm your email address and activate your MYTEC account. This will grant you full
        access to all learning features.
      </p>

      <div class="email-box">
        <span class="email-icon" aria-hidden="true">
          <i class="el-icon-user" />
        </span>
        <span class="email-content">
          <input
            v-model.trim="verifyCodeInput"
            class="email-input"
            type="text"
            autocomplete="off"
            placeholder="请输入校验码"
          >
          <span>MYTEC Student Account</span>
        </span>
      </div>

      <p class="secure-note">
        <i class="el-icon-lock" aria-hidden="true" />
        Your data is encrypted and secure
      </p>

      <button type="button" class="confirm-btn" @click="confirmEmail">
        <i class="el-icon-check" aria-hidden="true" />
        Confirm &amp; Activate Account
      </button>

      <p class="terms-text">
        By clicking, you agree to our Terms of Service and Privacy Policy
      </p>
    </section>

    <p class="support-text">
      Need help?
      <a href="">Contact Support</a>
    </p>

    <p class="page-tagline">AI TUTOR · THE FUTURE OF EDUCATION</p>
  </main>
</template>

<script>
export default {
  name: 'VerifyEmail',
  data () {
    return {
      verifyCodeInput: ''
    }
  },
  computed: {
    routeVerifyCode () {
      return this.$route.query.code || ''
    }
  },
  watch: {
    routeVerifyCode: {
      immediate: true,
      handler (code) {
        this.verifyCodeInput = code
      }
    }
  },
  methods: {
    /**
     * @description 获取当前校验码，优先取输入框内容。
     * @returns {string}
     */
    getCurrentVerifyCode () {
      return (this.verifyCodeInput || this.routeVerifyCode || '').trim()
    },

    /**
     * @description 校验输入并跳转到激活流程页。
     */
    confirmEmail () {
      const verifyCode = this.getCurrentVerifyCode()
      if (!verifyCode) {
        this.$message.warning('缺少校验码')
        return
      }

      this.$router.push({
        path: '/verify/activated',
        query: {
          code: verifyCode
        }
      })
    }
  }
}
</script>

<style scoped>
.email-verify-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 44px 20px 84px;
  background:
    radial-gradient(circle at 12% 22%, rgba(255, 255, 255, 0.72), transparent 30%),
    radial-gradient(circle at 88% 72%, rgba(219, 234, 254, 0.75), transparent 32%),
    linear-gradient(180deg, #f0edff 0%, #eef2ff 48%, #eef7ff 100%);
  color: #111827;
  font-family: "Inter", "Segoe UI", Arial, sans-serif;
}

.email-card {
  width: min(100%, 430px);
  padding: 38px 40px 31px;
  text-align: center;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 26px 70px rgba(99, 102, 241, 0.08);
}

.mail-visual {
  width: 78px;
  height: 78px;
  display: grid;
  place-items: center;
  margin: 0 auto 25px;
  border-radius: 17px;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed 0%, #5b21d6 100%);
  box-shadow: 0 12px 24px rgba(91, 33, 182, 0.22);
}

.mail-visual svg {
  width: 42px;
  height: 42px;
}

.title {
  margin: 0;
  color: #111827;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
}

.description {
  max-width: 350px;
  margin: 11px auto 28px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.55;
}

.email-box {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 18px 19px;
  text-align: left;
  border: 1px solid #ececf6;
  border-radius: 12px;
  background: #fbfaff;
}

.email-icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 10px;
  color: #fff;
  font-size: 20px;
  background: linear-gradient(135deg, #a855f7 0%, #7c3aed 100%);
}

.email-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.email-content strong {
  color: #111827;
  font-size: 14px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.email-input {
  width: 100%;
  min-height: 38px;
  padding: 0 10px;
  border: 1px solid #d7d9eb;
  border-radius: 8px;
  background: #fff;
  color: #111827;
  font-size: 14px;
  font-weight: 600;
  outline: none;
  box-sizing: border-box;
}

.email-input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.14);
}

.email-content span {
  color: #7c8494;
  font-size: 12px;
  font-weight: 600;
}

.secure-note {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 12px 0 28px;
  color: #8a6ad8;
  font-size: 12px;
  font-weight: 600;
}

.confirm-btn {
  width: 100%;
  min-height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 0;
  border-radius: 14px;
  padding: 0 22px;
  color: #fff;
  background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%);
  box-shadow: 0 12px 20px rgba(109, 40, 217, 0.2);
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(109, 40, 217, 0.26);
}

.terms-text {
  margin: 18px 0 0;
  color: #9aa2b1;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
}

.support-text {
  margin: 26px 0 0;
  color: #9aa2b1;
  font-size: 13px;
  font-weight: 600;
}

.support-text a {
  color: #7c3aed;
  font-weight: 700;
  text-decoration: none;
}

.support-text a:hover {
  text-decoration: underline;
}

.page-tagline {
  position: fixed;
  left: 50%;
  bottom: 22px;
  transform: translateX(-50%);
  color: #a6adbb;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

@media (max-width: 640px) {
  .email-verify-page {
    padding: 30px 18px 72px;
  }

  .email-card {
    padding: 34px 26px 30px;
  }

  .mail-visual {
    width: 70px;
    height: 70px;
  }

  .mail-visual svg {
    width: 38px;
    height: 38px;
  }

  .title {
    font-size: 24px;
  }

  .description {
    font-size: 13px;
  }
}

</style>
